import { post, IRequest } from '../index';
import {
	IGetConsumersListModel,
	ISearchConsumersListModel,
	IAddConsumerModel,
	IUpdateConsumerModel,
} from '../../models/consumers';

export const getConsumersListApi = (data: IGetConsumersListModel) => {
	const request: IRequest = {
		subUrl: '/consumer/list',
		data,
	};
	return post(request);
};

export const searchConsumersListApi = (data: ISearchConsumersListModel) => {
	const request: IRequest = {
		subUrl: '/consumer/list',
		data,
	};
	return post(request);
};

export const addNewConsumerApi = (data: IAddConsumerModel) => {
	const request: IRequest = {
		subUrl: '/consumer/add',
		data,
	};
	return post(request);
};

export const updateConsumerApi = (data: IUpdateConsumerModel) => {
	const request: IRequest = {
		subUrl: '/consumer/update',
		data,
	};
	return post(request);
};
